function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMobileRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 27a1 1 0 01-1 1H10a1 1 0 01-1-1V8c0-.542.458-1 1-1h12c.542 0 1 .458 1 1v19zM22 5H11V3a1 1 0 10-2 0v2.185C7.84 5.601 7 6.702 7 8v19a3 3 0 003 3h12a3 3 0 003-3V8c0-1.65-1.35-3-3-3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16h6v-5h-6v5zm-2 2h10V9H11v9zM11 22h2v-2h-2v2zM15 22h2v-2h-2v2zM11 26h2v-2h-2v2zM15 26h2v-2h-2v2zM19 22h2v-2h-2v2zM19 26h2v-2h-2v2z",
    fill: props.color
  }));
}

export default SvgIconMobileRexOutline;